// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/aerial_shot_cropped.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (width <= 600px) {
  .reset-form {
    padding: 30px;
    width: 100vw;
    height: 100vh;
  }

  .form-image {
    display: none;
    visibility: hidden;
  }
}

@media screen and (width >= 600px) {
  .reset-form__window {
    background-color: #e8f4f9;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
  }

  .reset-form__container {
    display: flex;
    background-color: white;
    width: 720px;
    height: 521px;
    border-radius: 6px;
    box-shadow: 0 20px 40px 0 rgb(0 26 6 / 20%);
  }

  .reset-form {
    padding: 30px;
    width: 300px;
    height: 521px;
  }

  .form-image {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 420px 521px;
    width: 420px;
    height: 521px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
}

.reset-password-header {
  line-height: 24px;
  margin: 20px 0 10px;
}

.reset-form--is-active .reset-form__input {
      border-bottom: 0;
    }

.reset-form--is-active .reset-form__control::after {
        border-bottom: 1px solid #24b248;
        border-radius: 0;
        transform: scaleX(200);
      }

.reset-form--is-active .reset-form__label {
      color: #24b248;
      font-size: 0.7rem;
      transform: translateY(-14px);
    }

.reset-form--is-filled .reset-form__label {
      font-size: 0.7rem;
      transform: translateY(-14px);
    }

.reset-form__container a {
  color: #007aff;
  line-height: 19px;
  text-decoration: none;
}

.reset-form__container p {
  color: #ababab;
  line-height: 19px;
  margin: 0 0 15px;
}

.reset-form__label {
  color: #ababab;
  display: block;
  font-weight: thin;
  left: 0;
  margin: 0;
  padding: 14px 0 0;
  position: absolute;
  top: 0;
  transition: all 0.25s;
  width: 100%;
}

.reset-form__control {
  overflow: hidden;
  position: relative;
  width: 100%;
}

.reset-form__control::after {
    border-bottom: 1px solid #24b248;
    border-radius: 0;
    bottom: 0;
    content: '';
    display: block;
    left: 0;
    margin: 0 auto;
    position: absolute;
    right: 0;
    transform: scaleX(0);
    transition: all 0.25s;
    width: 1%;
  }

.reset-form__input {
  background: transparent;
  border: 0 white;
  border-bottom: 1px solid #d8d8d8;
  border-radius: 0;
  color: #333;
  display: block;
  margin-top: 14px;
  outline: 0;
  padding: 4px 0;
  width: 100%;
}

.password-requirements-text {
  margin: 8px 0;
  height: 39px;
}

.password-requirements-text p {
    color: #ababab;
    font-size: 10px;
  }

.password-requirements-text .password-error-text {
    font-size: 10px;
    color: red;
    margin: 0;
  }

.reset-button {
  margin: 0 0 45px;
  height: 32px;
  width: 100%;
  border-radius: 32px;
  box-shadow: 0 10px 20px 0 rgb(0 26 6 / 20%);
}

.reset-button .r-button--primary {
    color: var(--color-grayscale-1);
    background-color: #24b248;
  }
`, "",{"version":3,"sources":["webpack://./app/pages/ResetPasswordPage/style.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;IACb,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,yDAA6D;IAC7D,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;EACjC;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAII;MACE,gBAAgB;IAClB;;AAGE;QACE,gCAAgC;QAChC,gBAAgB;QAChB,sBAAsB;MACxB;;AAGF;MACE,cAAc;MACd,iBAAiB;MACjB,4BAA4B;IAC9B;;AAIA;MACE,iBAAiB;MACjB,4BAA4B;IAC9B;;AAIJ;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,OAAO;EACP,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AAgBb;;AAdE;IACE,gCAAgC;IAChC,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,cAAc;IACd,OAAO;IACP,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,qBAAqB;IACrB,SAAS;EACX;;AAGF;EACE,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AAYd;;AAVE;IACE,cAAc;IACd,eAAe;EACjB;;AAEA;IACE,eAAe;IACf,UAAU;IACV,SAAS;EACX;;AAGF;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,2CAA2C;AAM7C;;AAJE;IACE,+BAA+B;IAC/B,yBAAyB;EAC3B","sourcesContent":["@media screen and (width <= 600px) {\n  .reset-form {\n    padding: 30px;\n    width: 100vw;\n    height: 100vh;\n  }\n\n  .form-image {\n    display: none;\n    visibility: hidden;\n  }\n}\n\n@media screen and (width >= 600px) {\n  .reset-form__window {\n    background-color: #e8f4f9;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100vw;\n    height: 100vh;\n  }\n\n  .reset-form__container {\n    display: flex;\n    background-color: white;\n    width: 720px;\n    height: 521px;\n    border-radius: 6px;\n    box-shadow: 0 20px 40px 0 rgb(0 26 6 / 20%);\n  }\n\n  .reset-form {\n    padding: 30px;\n    width: 300px;\n    height: 521px;\n  }\n\n  .form-image {\n    background-image: url('../../images/aerial_shot_cropped.jpg');\n    background-size: 420px 521px;\n    width: 420px;\n    height: 521px;\n    border-top-right-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n}\n\n.reset-password-header {\n  line-height: 24px;\n  margin: 20px 0 10px;\n}\n\n.reset-form {\n  &--is-active {\n    .reset-form__input {\n      border-bottom: 0;\n    }\n\n    .reset-form__control {\n      &::after {\n        border-bottom: 1px solid #24b248;\n        border-radius: 0;\n        transform: scaleX(200);\n      }\n    }\n\n    .reset-form__label {\n      color: #24b248;\n      font-size: 0.7rem;\n      transform: translateY(-14px);\n    }\n  }\n\n  &--is-filled {\n    .reset-form__label {\n      font-size: 0.7rem;\n      transform: translateY(-14px);\n    }\n  }\n}\n\n.reset-form__container a {\n  color: #007aff;\n  line-height: 19px;\n  text-decoration: none;\n}\n\n.reset-form__container p {\n  color: #ababab;\n  line-height: 19px;\n  margin: 0 0 15px;\n}\n\n.reset-form__label {\n  color: #ababab;\n  display: block;\n  font-weight: thin;\n  left: 0;\n  margin: 0;\n  padding: 14px 0 0;\n  position: absolute;\n  top: 0;\n  transition: all 0.25s;\n  width: 100%;\n}\n\n.reset-form__control {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n\n  &::after {\n    border-bottom: 1px solid #24b248;\n    border-radius: 0;\n    bottom: 0;\n    content: '';\n    display: block;\n    left: 0;\n    margin: 0 auto;\n    position: absolute;\n    right: 0;\n    transform: scaleX(0);\n    transition: all 0.25s;\n    width: 1%;\n  }\n}\n\n.reset-form__input {\n  background: transparent;\n  border: 0 white;\n  border-bottom: 1px solid #d8d8d8;\n  border-radius: 0;\n  color: #333;\n  display: block;\n  margin-top: 14px;\n  outline: 0;\n  padding: 4px 0;\n  width: 100%;\n}\n\n.password-requirements-text {\n  margin: 8px 0;\n  height: 39px;\n\n  p {\n    color: #ababab;\n    font-size: 10px;\n  }\n\n  .password-error-text {\n    font-size: 10px;\n    color: red;\n    margin: 0;\n  }\n}\n\n.reset-button {\n  margin: 0 0 45px;\n  height: 32px;\n  width: 100%;\n  border-radius: 32px;\n  box-shadow: 0 10px 20px 0 rgb(0 26 6 / 20%);\n\n  & .r-button--primary {\n    color: var(--color-grayscale-1);\n    background-color: #24b248;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
